export default {
  data(){
    return{

    }
  },
  methods:{
    getDefaultEnergyIds(){
      let obj={
        0:[1,2,3],
        1:[1],
        2:[2,3]
      }
      return obj[this.$route.query.type||0]
    },
    isEnergyAble(energyId){
      let energy_obj={};
      let query_type=(this.$route.query.type||0)*1
      switch (query_type) {
        case 1:energy_obj={1:true,2:false,3:false};break;
        case 2:energy_obj={1:false,2:true,3:true};break;
        default:energy_obj={1:true,2:true,3:true};break;
      }
      return energy_obj[energyId]||false;
    }
  },
  watch:{
    "$route.query.type":function (n) {
      typeof this.where.energy_ids!=="undefined"&&(this.where.energy_ids=this.getDefaultEnergyIds());
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/common/CommonMixin.js